import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import type { RootState } from '../../store';

// Common components
import PaymentModalV5 from '../../components/common/paymentModalV5';

import { setPaymentProduct } from '../../reduxStore/data/actions';
import { showPaymentModal, toggleLoader } from '../../reduxStore/navigation/actions';
import { getSinglePlanCheckoutConfig } from '../singlePlanCheckoutConfig';

function SinglePlanCheckout() {
  const dispatch = useDispatch();

  const product = useSelector((state: RootState) => state.data.paymentModal.product);
  const tariff = useSelector((state: RootState) => state.data.tariff);

  const showLoader = useCallback(
    (payload: boolean) => {
      dispatch(toggleLoader(payload));
    },
    [dispatch]
  );

  useEffect(() => {
    let timer: number | undefined;

    if (!product?.name) {
      showLoader(true);
    } else {
      timer = window.setTimeout(() => {
        showLoader(false);
      }, 400);
    }

    return () => {
      if (timer) window.clearTimeout(timer);
    };
  }, [product?.name, showLoader]);

  useEffect(() => {
    const cfg = getSinglePlanCheckoutConfig({
      tariff,
      period: 'month',
      sendContentIds: true,
    });

    const bodyEl = document.querySelector('body') as HTMLElement | null;
    const appEl = document.querySelector('.app') as HTMLElement | null;

    const prevBodyOverflowX = bodyEl?.style.overflowX;
    const prevAppOverflow = appEl?.style.overflow;

    if (bodyEl) bodyEl.style.overflowX = 'visible';
    if (appEl) appEl.style.overflow = 'visible';

    if (!product?.name) {
      const modalProductName = cfg.plan.productName ?? '';

      const paymentProductPayload = {
        product: cfg.plan.id,
        oldPrice: '29.99',
        name: modalProductName,
      };

      dispatch(setPaymentProduct(JSON.stringify(paymentProductPayload)));

      dispatch(
        showPaymentModal({
          product: modalProductName,
          currency: cfg.currencySymbol,
          price: String(cfg.plan.price),
        })
      );
    }

    return () => {
      if (bodyEl && typeof prevBodyOverflowX === 'string') bodyEl.style.overflowX = prevBodyOverflowX;
      if (appEl && typeof prevAppOverflow === 'string') appEl.style.overflow = prevAppOverflow;
    };
  }, [dispatch, tariff, product?.name]);

  return <PaymentModalV5 />;
}

export default SinglePlanCheckout;